const r=(r,t)=>r.find(r=>r.children===t),t=t=>{const n=["Frete Grátis","Entrega rápida","Retire Grátis na Loja"];for(const e of n){const n=r(t,e);if(n)return[n]}return[]};export{t as filterTags};
